import { Checkbox } from "@mui/material";
import React from "react";
import { color } from "../../../../common/MuiThemeProvider.js";
import type { DecisionContingencyCheckbox_ItemFragment } from "../../doc-items/fields/DecisionContingencyCheckbox.generated.js";
import type { ToggleContingencyFn } from "../quote/useContingencyCheckbox.js";

interface Props {
  item: DecisionContingencyCheckbox_ItemFragment;
  toggleContingency: ToggleContingencyFn;
  disabled?: boolean;
}

export const DataGridContingencyCheckboxCell = ({
  item,
  toggleContingency,
  disabled = false,
}: Props) => {
  const [loading, setLoading] = React.useState(false);
  const { decisionContingentItemPreselection } = item;

  return (
    <Checkbox
      size="small"
      color={loading || disabled ? undefined : "default"}
      style={loading || disabled ? undefined : { color: color.default }}
      disabled={loading || disabled}
      checked={Boolean(decisionContingentItemPreselection)}
      indeterminate={decisionContingentItemPreselection === null}
      onClick={async (event: React.ChangeEvent<any>) => {
        event.stopPropagation();
        event.preventDefault();
        let newPreselection: boolean | null = false;
        if (decisionContingentItemPreselection === null) newPreselection = true;
        if (decisionContingentItemPreselection === false)
          newPreselection = true;
        setLoading(true);
        try {
          await toggleContingency(item.id, newPreselection);
        } finally {
          setLoading(false);
        }
      }}
    />
  );
};
